<template>
  <div v-if="leagueType !== 'Supercup' || (leagueType === 'Supercup' && (!isOverviewPage || matches.length > 0))">
    <div>
      <p v-if="isOverviewPage && !loading" class="text-xl font-semibold pl-2.5 mb-2.5 mt-6 xl:pl-0">Najbliższe mecze</p>
    </div>
    <Transition name="fade" mode="out-in">
      <div v-if="!loading" class="border-zt-light rounded-zt border overflow-hidden" :class="[{'border-b-0' : noOfRounds !== 0}]">
        <div v-if="isReferee && !loading" class="bg-zt-light-full font-normal text-xs p-2.5 border-b border-zt-light">OBSADA SĘDZIOWSKA W NAJBLIŻSZYCH MECZACH</div>
        <p class="text-xs text-zt-more text-center font-normal w-full -leading-[0.18px] bg-zt-light-full p-2.5 "
           v-if="noOfRounds === 0">
          {{ isReferee ? 'Brak obsady. Sędziowie ustalani są najczęściej 1-2 dni przed rozpoczęciem kolejki ligowej' : 'Brak meczów do wyświetlania' }}
        </p>
        <div v-for="(value, key, rIndex) in roundsToShow" :key="key" class="flex flex-col items-start w-full">
          <div v-if="value.round_matches.length > 0 && !isReferee" class="flex  border-b border-zt-light gap-x-[7px] text-xs font-normal -leading-[0.18px] bg-zt-light-full px-[15px] py-2.5 w-full">
            <component :is="redirectInHeader ? 'a' : 'div'" :href="getUrl(value)"
                       :class="redirectInHeader ? 'cursor-pointer zt-hover' : ''"
                       class="no-default-style flex gap-x-[7px] w-full">
              <div class="w-[15px] h-[11px] mt-[1px]">
                <img ref="CountryImg" class="w-full h-full rounded-[2px]" :src="countryFlag" :alt="countryName"
                     :class="{ 'translate-y-px' : countryName === 'Świat' }">
              </div>
              <span v-if="[34, 32].includes(+value.round_matches[0].league_id)">
                El. Mistrzostw Świata ({{ +value.round_matches[0].league_id === 34 ? 'Ameryka Poł.' : 'Europa' }}) {{ WP.team ? '' : '-' }} {{getMatchRoundString(key).replace('Faza Grupowa -', '')}}
              </span>
              <span v-else-if="leagueType === 'Cup'">
                {{ countryName.toUpperCase() }}: Puchar - {{ cupRoundName(key, 0, value.round_matches[0].matches_count_in_round ?? 0) }}
              </span>
              <span v-else-if="leagueType === 'European Cup' || leagueType === 'National Cup'">
                {{ leagueName }} - {{ cupRoundName(key) }} {{ [2,3,848].includes(Number(leagueId)) && cupRoundName(key).includes('Play-offy') ? '- Finał' : '' }}
              </span>
              <span class="whitespace-nowrap overflow-ellipsis overflow-hidden max-w-full" v-else>
                {{ getRegionString(value.round_matches[0].league_query_name, countryName.toUpperCase()) }}:
                {{ getTournamentNameString(value.round_matches[0].league_query_name) }}
                {{ WP.team?.country !== 'World' ? leagueName : '' }} {{ getMatchRoundString(key) }}
              </span>
            </component>
          </div>
          <div v-if="!history" v-for="(match, index) of value.round_matches" class="w-full">
            <FootballStatsListItem v-if="match.status !== 'PLACEHOLDER'" class="!border-x-0"
                                   :redirect-to-h2h="match.is_h2h_available && ((leagueType !== 'Cup' && leagueType !== 'European Cup' && leagueType !== 'National Cup')
                                     || (match.league_query_name === 'euro' || match.league_query_name === 'copa-america'))"
                                   :analytic-type="isOverviewPage ? 'league-overview-timetable' : 'league-timetable'"
                                   :show-h2h-button="(match.league_query_name === 'euro'
                                     || match.league_query_name === 'copa-america')"
                                   :show-teams-bg="showTeamsBgs"
                                   :short-league-name="[32, 34].includes(+match.league_id) && showLeagueName ? 'eMŚ' : ''"
                                   :class="{ '!rounded-b-zt' : value.round_matches.length - 1 === index && noOfRounds - 1 === rIndex
                                      && !(isOverviewPage && noOfRounds > 0 && leagueType !== 'Supercup') }"
                                   :is-timetable-page="true" :match="match" show-odds show-date show-hour :isReferee="isReferee"/>
            <match-placeholder v-else :match="match"/>
          </div>
          <div v-else v-for="(match, index) of value.round_matches.slice().reverse()" class="w-full">
            <FootballStatsListItem v-if="match.status !== 'PLACEHOLDER'" class="!border-x-0"
                                   :redirect-to-h2h="match.is_h2h_available && ((leagueType !== 'Cup' && leagueType !== 'European Cup' && leagueType !== 'National Cup')
                                     || (match.league_query_name === 'euro' || match.league_query_name === 'copa-america'))"
                                   :analytic-type="isOverviewPage ? 'league-overview-timetable' : 'league-timetable'"
                                   :show-h2h-button="(match.league_query_name === 'euro'
                                     || match.league_query_name === 'copa-america')"
                                   :short-league-name="[32, 34].includes(+match.league_id) && showLeagueName ? 'eMŚ' : ''"
                                   :show-promotion-icon="getPromotionIcon(match, key)"
                                   :class="{ '!rounded-b-zt' : value.round_matches.length - 1 === index && noOfRounds - 1 === rIndex
                                      && !(isOverviewPage && noOfRounds > 0 && leagueType !== 'Supercup') }"
                                   :is-timetable-page="true" :match="match" show-odds show-date show-hour/>
            <match-placeholder v-else :match="match"/>
          </div>
        </div>
        <div v-if="(noOfRounds > amount) && !isOverviewPage"
             class="py-4 flex items-center bg-zt-light/35 border-zt-light border-b justify-center text-zt-more text-xs
                    underline font-normal uppercase rounded-b-zt">
          <span class="cursor-pointer zt-hover" @click="amount += 2">Rozwiń</span>
        </div>
        <div v-else-if="singleMatchesAmount !== 0 && singleMatchesAmount < noOfMatches && noOfDisplayedMatches < noOfMatches"
             class="py-4 flex items-center rounded-b-zt border-b bg-zt-light/35 border-zt-light justify-center
                    text-zt-more text-xs underline font-normal uppercase">
          <span class="cursor-pointer zt-hover" @click="singleMatchesAmount += 20">Rozwiń</span>
        </div>
        <div v-if="isOverviewPage && noOfRounds > 0 && leagueType !== 'Supercup'"
             class="py-4 flex items-center rounded-b-zt bg-zt-light/35 border-zt-light border-b justify-center
                    text-zt-more text-xs font-normal uppercase">
          <a data-count-click="WIĘCEJ MECZÓW w PRZEGLĄDZIE LIGI (najbliższe mecze)" href="terminarz/"
             class="no-default-style cursor-pointer zt-hover">
            <span class="underline mr-[7px]">Więcej meczów</span>
            <svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
              <path d="M10.3722 13.255L16.0405 6.62748L10.3722 0L9.44646 1.08243L13.5556 5.86789L3.24219 5.86789L3.24219 7.38708L13.5556 7.38708L9.44646 12.1725L10.3722 13.255Z" fill="#93A3BA"/>
              <path d="M1.29932 5.86719H0L0 7.38638H1.29932L1.29932 5.86719Z" fill="#93A3BA"/>
            </svg>
          </a>
        </div>
      </div>
      <div v-else-if="history">
        <div class="border border-zt-light mb-4 overflow-hidden animate-pulse rounded-zt">
          <div class="bg-zt-light/35 border-b border-zt-light w-full flex items-center p-3">
            <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
          </div>
          <div v-for="i in 10" class="border-b border-zt-light bg-zt-light/35 w-full h-[45px] flex items-center p-2">
            <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
          </div>
          <div class="border-zt-light bg-zt-light/35 w-full h-[48px] flex justify-center items-center p-2">
            <div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
          </div>
        </div>
      </div>
      <div v-else-if="loading && isReferee" class="rounded-zt border border-zt-light">
        <div class="bg-zt-light-full font-normal text-xs p-2.5 border-b border-zt-light">OBSADA SĘDZIOWSKA W NAJBLIŻSZYCH MECZACH</div>
        <p class="text-xs text-zt-more text-center font-normal w-full -leading-[0.18px] bg-zt-light-full p-2.5 ">
          <svg class="w-4 h-4 animate-spin fill-zt-red mx-auto" viewBox="0 0 100 101">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
          </svg>
        </p>
      </div>
    </Transition>
  </div>
</template>

<script>
import FootballStatsListItem from '../components/blocks/FootballStatsListItem.vue';
import football_mixin from "../mixins/football_mixin";
import {ladderPlaceholders} from "../../assets/js/ladder-placeholders";
import MatchPlaceholder from '../components/football_stats/blocks/MatchPlaceholder.vue';

export default {
	name: 'FootballLeagueTimetable',
	components: { MatchPlaceholder, FootballStatsListItem},
	mixins: [football_mixin],
	inject: ['WP'],
  emits: ['loaded'],
	props: {
		showPromotionIcon: {
			type: Boolean,
			default: false
		},
    extraLeagueId: Number,
    extraLeagueName: String,
    extraCountryName: String,
    extraCountryQueryName: String,
    extraMatchesAmount: Number,
    extraSeason: Number,
    extraLeagueType: String,
    placeholderName: String,
    extraAmount: Number,
    isReferee: {
      type: Boolean,
      default: false
    },
    showTeamsBgs: {
      type: Array,
      default: []
    },
    redirectInHeader: {
      type: Boolean,
      default: false
    },
    showLeagueName: {
      type: Boolean,
      default: true
    }
	},
	data() {
		return {
			rounds: this.$attrs.rounds ?? [],
			amount: this.extraAmount ?? 4,
      singleMatchesAmount: +this.$attrs.matchesAmount ?? 0,
			loading: true,
      roundsEntries: []
		}
	},
	computed: {
    worldCupMergedMatches() {
      const data = JSON.parse(JSON.stringify(this.rounds));
      const targetLeagueIds = new Set(["34", "32"]);
      const mergedMatches = { "round_matches": [] };

      for (const [roundName, roundData] of Object.entries(data)) {
        if (roundData.round_matches.length === 1) {
          const match = roundData.round_matches[0];

          if (targetLeagueIds.has(match.league_id)) {
            mergedMatches.round_matches.push(match);
            delete data[roundName];
          }
        }
      }

      if (mergedMatches.round_matches.length > 0) {
        data["Merged Matches"] = mergedMatches;
      }

      const entries = Object.entries(data).sort((a, b) => {
        const getClosestMatchDate = (round) => {
          return new Date(Math.min(...round.round_matches.map(match => new Date(match.date))));
        };
        return getClosestMatchDate(a[1]) - getClosestMatchDate(b[1]);
      });

      return entries;
    },
		roundsToShow() {
			if (!this.loading) {
				if (this.rounds.length === 0 || Object.keys(this.rounds).length === 0) {
					return [];
				}
        let tempRounds = Object.entries(this.rounds).slice();
        let matchesCount = this.noOfDisplayedMatches ? this.noOfDisplayedMatches : this.singleMatchesAmount;
        if (matchesCount) {
          let lastRound = Object.fromEntries(
              tempRounds.slice(0, 1)
          );
          const roundName = Object.keys(lastRound)[0];
          let round = {};
          round[roundName] = {};
          round[roundName].round_matches = lastRound[roundName].round_matches.slice(0, matchesCount);
          let noMissingMatches = matchesCount - round[roundName].round_matches.length;
          if (!noMissingMatches > 0) {
            return round;
          }

          let noOfRounds = Object.keys(tempRounds).length;

          for (let i = 1; i < noOfRounds - 1; i++) {
            let nextRound = Object.fromEntries(
                tempRounds.slice(i, i + 1)
            );
            const nextRoundName = Object.keys(nextRound)[0];
            round[nextRoundName] = {};
            round[nextRoundName].round_matches = [...nextRound[nextRoundName].round_matches.slice(0, noMissingMatches)];
            noMissingMatches -= round[nextRoundName].round_matches.length;
            if (!noMissingMatches > 0) {
              return round;
            }
          }
        }

        if (this.WP.team) {
          const entries = this.worldCupMergedMatches;
          return Object.fromEntries(entries.slice(0, this.amount));
        }

				if (this.isOverviewPage) {
					const nextFullRound = Object.fromEntries(
						Object.entries(this.rounds).slice(1, 2)
					);

					const round = Object.fromEntries(
						Object.entries(this.rounds).slice(0, 1)
					);

					if (Object.keys(nextFullRound).length === 0) {
						return round;
					}

					const roundName = Object.keys(round)[0];

					const nextRoundName = Object.keys(nextFullRound)[0];

					const roundMatches = round[roundName].round_matches.length;

					if (roundMatches === this.teams.length / 2) {
						return round;
					}

					const missingMatches = this.teams.length / 2 - roundMatches;

					round[nextRoundName] = {};
					round[nextRoundName].round_matches = [...nextFullRound[nextRoundName].round_matches.slice(0, missingMatches)];
					return round;

				}
				return Object.fromEntries(
					this.history ? Object.entries(this.rounds).slice().reverse().slice(0, this.amount) : Object.entries(this.rounds).slice(0, this.amount)
				);
			}
		},
		noOfDisplayedMatches() {
      if (this.extraMatchesAmount) {
        return this.extraMatchesAmount;
      }
			return +this.$attrs.noOfDisplayedMatches || false;
		},
		leagueType() {
      if (this.extraLeagueType) {
        return this.extraLeagueType;
      }
			return this.$attrs.leagueType || 'league';
		},
		isOverviewPage() {
			if (!this.$attrs.isOverview) {
				return false;
			}
			return this.$attrs.isOverview === 'true';
		},
		noOfRounds() {
      if (this.WP.team) {
        return Object.keys(this.worldCupMergedMatches).length;
      }
			return Object.keys(this.rounds).length;
		},
    matches() {
      if (this.rounds) {
        return Object.values(this.rounds).flatMap(round => round.round_matches);
      }
      return [];
    },
    noOfMatches() {
      return this.matches.length;
    },
		leagueId() {
      if (this.extraLeagueId) {
        return this.extraLeagueId;
      }
			return +this.$attrs.leagueId ?? -1;
		},
		teams() {
			if (this.isOverviewPage) {
				return JSON.parse(this.$attrs.teams);
			}
			return [];
		},
		leagueName() {
      if (this.extraLeagueName) {
        return this.extraLeagueName;
      }
			return this.$attrs.leagueName;
		},
		countryName() {
      if (this.extraCountryName) {
        return this.extraCountryName;
      }
			return this.$attrs.countryName;
		},
    countryQueryName() {
      if (this.extraCountryQueryName) {
        return this.extraCountryQueryName;
      }
      return this.$attrs.countryQueryName;
    },
		countryFlag() {
			return `/wp-content/themes/zawodtyper/assets/images/kraje/${this.countryQueryName.toLowerCase()}.svg`;
		},
    season() {
      if (this.extraSeason) {
        return this.extraSeason;
      }
      return this.$attrs.season ?? null;
    },
    history() {
      return this.$attrs.history ?? false;
    }
	},
  mounted() {
    if (this.rounds.length === 0) {
      let statuses = [4, 9].includes(this.leagueId) ? ['FT', 'PEN', 'AET', 'TBD', 'NS', 'PST'] : ['TBD', 'NS', 'PST'];
      if (this.history) {
        statuses = ['FT', 'AET', 'PEN', 'PST', 'CANC', 'ABD', 'AWD', 'WO'];
      }
      if (this.isReferee) {
        statuses = ['TBD', 'NS', 'PST', '1H', '2H', 'HT', 'ET', 'EN', 'AET', 'PEN', 'FT'];
      }
      axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_league_matches',
        league_id: this.leagueId,
        season: this.season,
        status_array: statuses,
        order: 'ASC',
        qualification: this.$attrs.qualification ?? false,
        referee: this.isReferee
      }).then(response => {
        this.rounds = response.data.data;
        if (this.isReferee) {
          this.rounds = this.filterUpcomingMatches(this.rounds);
        }
        if (this.leagueId === 4 || this.leagueId === 9) {
          const placeholders = this.leagueId === 4 ? ladderPlaceholders.Euro.rounds : ladderPlaceholders.Copa.rounds;
          if (Object.keys(this.rounds).length > 0 && Object.keys(placeholders).length > 0 &&
              Object.keys(this.rounds).slice().filter(key => !key.includes('Group Stage')).length < Object.keys(placeholders).length) {
            this.updateRoundsWithPlaceholders(placeholders, response.data.data);
          }
          this.rounds = Object.fromEntries(this.filterRounds(this.rounds));
        }
        this.loading = false;
        this.$emit('loaded');
        this.removePlaceholder(this.$attrs.section ?? this.placeholderName);
      });
    } else {
      this.loading = false;
      this.$emit('loaded');
    }
  },
  methods: {
    getUrl(value) {
      if (value.round_matches[0].league_id === '34' || value.round_matches[0].league_id === '32') {
        return `/wyniki-pilka-nozna/swiat/mundial/kwalifikacje/`;
      }

      return `/wyniki-pilka-nozna/${value.round_matches[0].country_query_name}/${value.round_matches[0].league_query_name}/`;
    },
	  getPromotionIcon(match, round) {
			if (!this.showPromotionIcon) {
				return false;
			}
		  return (this.leagueType === 'Cup' || this.leagueType === 'Supercup' || ((this.leagueType === 'European Cup' || this.leagueType === 'National Cup') && !round.includes('Group') && !round.includes('League')))
			  && (match.double_match.is_double_match && match.double_match.match_no === 2 || !match.double_match.is_double_match);
	  },
    getRegionString(league_query_name, default_region) {
      switch (league_query_name) {
        case 'euro' :
          return 'EUROPA';
        case 'copa-america' :
          return 'AMERYKA'
        default :
          return default_region;
      }
    },
    getTournamentNameString(league_query_name) {
      switch (league_query_name) {
        case 'euro' :
          return 'Euro';
        case 'copa-america' :
          return 'Copa America'
	      case 'liga-narodow-uefa' :
		      return 'Liga Narodów UEFA -'
        default :
          return '';
      }
    },
    parseRoundDate(dateStr) {
      let finalDate = '';
      if (dateStr.includes('-')) {
        let [date, time] = dateStr.split(' ');
        let [year, month, day] = date.split('-');
        finalDate = `${day}.${month}.${year} ${time}`;
      } else {
        let [date, time] = dateStr.split(' ');
        finalDate = `${date}.${new Date().getFullYear()} ${time}`;
      }
      return new Date(finalDate);
    },
    updateRoundsWithPlaceholders(placeholdersRounds, responseData) {
      const roundsEntries = Object.entries(placeholdersRounds);

      this.rounds = placeholdersRounds;
      this.roundsEntries = roundsEntries.map(([roundName, roundData]) => {
        const updatedRoundMatches = roundData.round_matches.map(match => {
          const responseRoundData = responseData[roundName];
          if (responseRoundData) {
            const index = responseRoundData.round_matches.findIndex(el =>
                el.visitorteam_team_query_name === match.visitorteam_team_query_name &&
                el.localteam_team_query_name === match.localteam_team_query_name
            );
            if (index !== -1) {
              return responseRoundData.round_matches[index];
            }
          }
          return match;
        });

        return [roundName, { ...roundData, round_matches: updatedRoundMatches }];
      });

      this.roundsEntries.forEach(([roundName, roundData], roundIndex) => {
        roundData.round_matches.forEach((match, matchIndex) => {
          if (this.checkStatus(match.status)) {
            const nextRoundIndex = roundIndex + 1;
            const nextMatchIndex = Math.floor(matchIndex / 2);
            const winningTeam = +match.localteam_goals > +match.visitorteam_goals ? {
              team_name: match.localteam_shortname ? match.localteam_shortname : match.localteam_name,
              team_query_name: match.localteam_team_query_name
            } : +match.localteam_goals < +match.visitorteam_goals ? {
              team_name: match.visitorteam_shortname ? match.visitorteam_shortname : match.visitorteam_name,
              team_query_name: match.visitorteam_team_query_name
            } : +match.localteam_penalty_shootout > +match.visitorteam_penalty_shootout ? {
              team_name: match.localteam_shortname ? match.localteam_shortname : match.localteam_name,
              team_query_name: match.localteam_team_query_name
            } : {
              team_name: match.visitorteam_shortname ? match.visitorteam_shortname : match.visitorteam_name,
              team_query_name: match.visitorteam_team_query_name
            };

            if (this.roundsEntries[nextRoundIndex]) {
              const nextRoundMatches = this.roundsEntries[nextRoundIndex][1].round_matches[nextMatchIndex];
              if (matchIndex % 2 === 0) {
                nextRoundMatches.top_team = winningTeam.team_name;
                nextRoundMatches.localteam_team_query_name = winningTeam.team_query_name;
              } else {
                nextRoundMatches.bottom_team = winningTeam.team_name;
                nextRoundMatches.visitorteam_team_query_name = winningTeam.team_query_name;
              }
            }
          }
        });
      });

      this.filterRounds(Object.fromEntries(this.roundsEntries));
      this.rounds = Object.fromEntries(this.roundsEntries);
    },
    filterRounds(rounds) {
      let tempRounds = Object.entries(rounds).map(([roundName, roundData]) => {
        roundData.round_matches = roundData.round_matches.filter(match =>
            ['TBD', 'NS', 'PST', 'PLACEHOLDER'].includes(match.status)
        );
        if (roundData.round_matches && roundData.round_matches.length > 0) {
          roundData.round_matches.sort((a, b) => {
            const dateA = this.parseRoundDate(a.date);
            const dateB = this.parseRoundDate(b.date);
            return dateA - dateB;
          });
          return [roundName, roundData];
        }
      })
      return tempRounds.filter(el => el !== undefined);
    },
    filterUpcomingMatches(data) {
    const now = new Date();
    const threeHoursAgo = new Date(now.getTime() - (3 * 60 * 60 * 1000));

    Object.keys(data).forEach(roundKey => {
      if (data[roundKey].round_matches) {
        data[roundKey].round_matches = data[roundKey].round_matches.filter(match => {
          const matchDate = new Date(match.date);
          return matchDate > threeHoursAgo;
        });

        if (data[roundKey].round_matches.length === 0) {
          delete data[roundKey];
        }
      }
    });

  return data;
  }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;

}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>